import { Theme } from '@mui/material/styles'

const useStyles = {
  errorText: (theme: Theme) => ({
    marginTop: theme.spacing(-0.5),
    marginLeft: theme.spacing(0),
    color: theme.palette.error.main,
  }),
  input: (theme: Theme, disabled: boolean | undefined) => ({
    '& .MuiFilledInput-root': {
      backgroundColor: disabled ? theme.palette.ui.disabledStateColor : theme.palette.ui.surfaceContainerLow,
      '&.Mui-focused, &:hover': {
        backgroundColor: theme.palette.ui.surfaceContainerLow,
      },
    },
    '& .MuiInputLabel-filled,& .MuiInputLabel-filled.Mui-focused': {
      color: theme.palette.ui.onSecondaryFixed,
      opacity: 0.7,
    },
  }),
}

export default useStyles
